export default __webpack_public_path__ + "static/media/img8.141e4c6c.png";